
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as index9bDm23bFfesUx1nTWJRS7pbfMzoLCzU_iA6ivSJO6hgMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/index.vue?macro=true";
import { default as login8PYPykC1N8Z0m8FgvNXpLlEYiOswlfy49KpcEKMlNr4Meta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createw3Dcdht1LkKbTfCa7YRSa0OElqHL022m1GheOnBSiGAMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgotWn28xIhc_45LsQu009mL8ihacIiWLq_UtI1edzKZvT_3QMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportsc5vkw6uQ2iONT_45vouZ2hw8kYh2hVzxrplBy1PymBPVkMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45up19SLkyMYlLo__45cHeMVllpszFeyHElEBD5JybAlXcSnsMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insights3qLpQeBtI0kM5jbCI1Wof05wDbGgj1Ez4gu526p5yrcMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as newdJ7kRWAH3JJW2e_esGGFlN7Xx1ThJdUt5KGi0oP3buIMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newu6aG32Wxvnf8GipcxSCchDQ55g4iplafkZvg32vaqn8Meta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as new3SJk_zMOX0i7MjvLsppepp3_hN7Y4XY8SLhNIwrufUYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93S1OPTTwyDNzHq_N_wBv3H_xhE2ErxQ0O990Sr0oRhFgMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newAt5cXh0najazfBqAcXRyieKuCuXo_45qa_XAFN4XJxnwUMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93jmt0dlZL0Ik5b8_bPhbj0dPrf0RB_H_OSTnMX7LVn5wMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newhfSUnGCT3XeTR5wOGGF0h2GrY_45_45MTrJ_FQsNNLiEwPMMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as index_mbFHnNtQL_45sEk2EaKg4EDxIgkWDwPzQoZqderRs1ogMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_93z8TZdq3oSpyQKeZ9SBX3V_454merdxGvb59_45Sv94HmRN0Meta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrationsLH__ttMQ10gLKzuVroYXSXCQmW9iq1ixvE2dChnNlPgMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as indexYfSwLyKUk8f82sNkJJkWKuSx39RkT5JZ_QH9vBTZKWYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as indexgIsjazfzGRXlwgZd6tU5TOuqKoPfNHZ3GWw4qGU_45pdcMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newqr5_45WQyB5BpeT3gyvBaktdxH57lSvOHmdcnCzktgfB0Meta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newrhFmkNq3i7fydvJNHJUqAM3lzb4Tlq0_OSTLgffNapAMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexUnOpvv0_WSBN2qdvJ06E5ASa6oI3egR_ErYT2_uT9AwMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_93s327G5z3V8wiidgcUVHp2gt8T8HHxwyABIKWQApANmgMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newS0wS6MrRdJXXpbLTjr4JukymJIkePbi5MK15QCurOjYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as newEMITHEFqADfNhY1xNoxKm86VoFxXscoyvZPqi2rxVLoMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93Zjdjn4K0gMpMB1byDhi4bHspQmD7g5wxakRBu_45oGSIYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93g50lpSHms8yP8nyqKHCXmqeJBqpXNFAIHH49yxGzrKwMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_93rWE8vik7xavdp_45rH47iblWA31ecn8WoRc6paV7YOI7cMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as index6rlN_45CKc0eDOOm_KSWCGVT8hsFOVw6cWETpNHCkXF9oMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_93Nhheay2KD8ynSOWp_BoFqFFtCsm66LPKqXLoawDBOsYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93WlUs4OoL3k8_twpDAerDZ0NYo_45nGoFPAqgtSm7lbqjUMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93xrFuth7kpmz9__45hbRE9XxiNTRWW25ZcooRhqZxRs8hkMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as downloadPLN4gfaBsW2IbxcW6grerTXvz_mFBE8ptHpYNj3GNpAMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexYEO2mTWIGTyLxvKHF2RXuEpKQpEePuY3v2W_45VHbjFmMMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as indexAvygDczJhlhzPyoM3k1AYk1d4OuzB5sWfkC_45rzlXXgYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexugXoEF_kIOz_455JhIln2GZcQhnoW9mC6jNdAhbdVNfREMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as new_45TmJHG9o7b32YgBXUQkvnOHtzdBb_8IEB1mXlNivosUMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexx4T5X7tq3vTUjCClBYebkATM6inITt_45dod7qwl9IMccMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexlBGbI_45Suis4nHGUxVUzAm2xRkzpU3dnwsmDWEtaurqYMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_93odr6EPfnkddQSZThMrPJHGwJQMkPYLs7AhGzNLHmeoEMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexj7QUVny9s9MORwRUOlc_45FZsOUjaMZHu6ROH5w_457S2fMMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as index0on7JTT_S_45RKW02wWb_FFlwOuJQyqPxOst3OpOtKG3IMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newyfjJly5QDBzEZqDYeer7OSIGwFg4t6vd8QuOuoAfP4oMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93rtGlKc4oJnm_45O_45_ENXsuYMUrZpPWgTuAbIGlFS95MoIMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexA9oylLdy5NBIYR0L2aSHhcD0nYF4USUMIg9OHvsAoawMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as newlqtwy3rrlnV2TrU8GTQU8H5mYpwD68_45Usr6B07TRR2EMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_93cnOWw3d5DBA9ziqys_eZmxG2mPKHoSKUfxOgQBOlEWIMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indextBttDq4Zjg_45zUFklkgDRhigisR0HvYD6f4XwfAVqArAMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newmDnCgWqWoRMTgVUqe11WNizeQJ2p_45bDCr5WJNV29G3AMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93Yp2cJnyqG39i_wOlWN8gSZcEt4UabC9AN6M95yRWwZkMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as index1nB_OC98INE_Lmug9yTu8NRAa1TS6X_VbsU4EpKgRegMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_93glLcoG0fexzFkmes0VZai1yMU6A1JV_45UY0fAK6yDuKAMeta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45historyyM5WycrRfPGJiGPPLdGvHzBGKiJbaQkozXzk_45XoIqx8Meta } from "/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src3960793140/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]